import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Layout } from './components/Layout';
import PrototypeBanner from './components/PrototypeBanner';

import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import DirectoryPage from './pages/DirectoryPage';
import ContactDetailPage from './pages/ContactDetailPage';
import AgencyListPage from './pages/AgencyListPage';
import AgencyDetailPage from './pages/AgencyDetailPage';
import ListsPage from './pages/ListsPage';
import FlagsPage from './pages/FlagsPage';
import PendingChangesPage from './pages/PendingChangesPage';
import UpdateRequestsPage from './pages/UpdateRequestsPage';
import KPIDashboardPage from './pages/KPIDashboardPage';
import ImportExportPage from './pages/ImportExportPage';
import UserManagementPage from './pages/UserManagementPage';
import RoleManagementPage from './pages/RoleManagementPage';
import RoleCapabilitiesPage from './pages/RoleCapabilitiesPage';
import AuditLogPage from './pages/AuditLogPage';
import SettingsPage from './pages/SettingsPage';
import QuickSendPage from './pages/QuickSendPage';

const App: React.FC = () => {
  return (
    <>
      <PrototypeBanner />
      <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<LoginPage />} />

      <Route path="/dashboard" element={<ProtectedRoute><Layout><DashboardPage /></Layout></ProtectedRoute>} />
      <Route path="/directory" element={<ProtectedRoute><Layout><DirectoryPage /></Layout></ProtectedRoute>} />
      <Route path="/contacts/:id" element={<ProtectedRoute><Layout><ContactDetailPage /></Layout></ProtectedRoute>} />
      <Route path="/agencies" element={<ProtectedRoute><Layout><AgencyListPage /></Layout></ProtectedRoute>} />
      <Route path="/agencies/:id" element={<ProtectedRoute><Layout><AgencyDetailPage /></Layout></ProtectedRoute>} />
      <Route path="/lists" element={<ProtectedRoute><Layout><ListsPage /></Layout></ProtectedRoute>} />

      <Route path="/flags" element={<ProtectedRoute><Layout><FlagsPage /></Layout></ProtectedRoute>} />
      <Route path="/pending" element={<ProtectedRoute minRole="Superuser"><Layout><PendingChangesPage /></Layout></ProtectedRoute>} />
      <Route path="/update-requests" element={<ProtectedRoute minRole="Superuser"><Layout><UpdateRequestsPage /></Layout></ProtectedRoute>} />
      <Route path="/kpi" element={<ProtectedRoute minRole="Superuser"><Layout><KPIDashboardPage /></Layout></ProtectedRoute>} />
      <Route path="/import" element={<ProtectedRoute><Layout><ImportExportPage /></Layout></ProtectedRoute>} />

      <Route path="/admin/users" element={<ProtectedRoute minRole="Administrator"><Layout><UserManagementPage /></Layout></ProtectedRoute>} />
      <Route path="/admin/roles" element={<ProtectedRoute minRole="Administrator"><Layout><RoleManagementPage /></Layout></ProtectedRoute>} />
      <Route path="/admin/audit-log" element={<ProtectedRoute minRole="Administrator"><Layout><AuditLogPage /></Layout></ProtectedRoute>} />
      <Route path="/admin/settings" element={<ProtectedRoute minRole="Administrator"><Layout><SettingsPage /></Layout></ProtectedRoute>} />
      <Route path="/capabilities" element={<ProtectedRoute><Layout><RoleCapabilitiesPage /></Layout></ProtectedRoute>} />

      <Route path="/quick-send" element={<ProtectedRoute><QuickSendPage /></ProtectedRoute>} />

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </>
  );
};

export default App;
